import { useEffect, useRef, useState } from "react";
import "./data-entry-step4.scss";

import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { DataEntryStepProps } from "src/types";
import { useResponsiveBp } from "src/utils/hook-functions/responsive-bp.hook";
import { atomPolicy } from "src/storage";

export const useDataEntryStep4 = ({ formik }: DataEntryStepProps) => {
  const { t } = useTranslation();
  const { isDesktop } = useResponsiveBp();

  // Manage resume purchase height
  const col1Ref = useRef<HTMLDivElement>(null);
  const [col1Height, setCol1Height] = useState<number | undefined>();
  // ================================================================

  const [insuredListExpanded, setInsuredListExpanded] = useState(false);

  const policy = useRecoilValue(atomPolicy);
  const continueDisabled =
    !policy?.premioTotale ||
    !formik.values.consentTd ||
    !formik.values.informativeVision;

  useEffect(() => {
    if (col1Ref.current) {
      const height = col1Ref.current.offsetHeight;

      setCol1Height(height);
    }
  }, [formik.values.insuredList]);

  return {
    isDesktop,
    continueDisabled,
    col1Height,
    col1Ref,
    insuredListExpanded,
    t,
    setInsuredListExpanded,
  };
};
